<template>
  <div
    v-show="scormLaunched"
    class="scorm-player-wrapper"
    :style="{ minHeight: iframeHeight }"
  >
    <div v-if="scormLoading && !useNativePlayer" class="scorm-iframe-loader">
      <div class="scorm-iframe-loader__content text-center">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="sr-only">{{ $t('page.general.cargar') }}</span>
        </div>
        <p class="scorm-iframe-loader__text mb-0">Se está cargando el contenido...</p>
      </div>
    </div>

    <div v-show="useNativePlayer && cveTema > 0" class="scorm-player-host">
      <ScormPlayer
        v-if="scormLaunched && useNativePlayer"
        :cve-tema="cveTema"
        :iframe-height="iframeHeight"
        @ready="onScormReady"
        @exit="$emit('exit')"
        @error="onScormError"
      />
    </div>
    <div
      v-show="!useNativePlayer"
      :id="legacyHostId"
      ref="legacyScormHost"
      class="scorm-player-host"
    />
  </div>
</template>

<script>
import ScormPlayer from '@scorm/components/ScormPlayer.vue';
import { isNativeScormLink, launchScormIframe } from '@/utils/scormIframeLauncher';

export default {
  name: 'ScormMaterialGate',
  components: { ScormPlayer },
  props: {
    requerimiento: { type: Object, required: true },
    cveEmpleado: { type: [String, Number], required: true },
    iframeHeight: { type: String, default: '45em' },
  },
  data() {
    return {
      scormLaunched: false,
      scormLoading: false,
      legacyHostId: 'scorm-legacy-host-' + Math.random().toString(36).slice(2),
    };
  },
  computed: {
    useNativePlayer() {
      return isNativeScormLink(this.requerimiento && this.requerimiento.link);
    },
    cveTema() {
      return Number(this.requerimiento && this.requerimiento.cve_tema) || 0;
    },
  },
  mounted() {
    this.$nextTick(() => this.launchScorm());
  },
  beforeDestroy() {
    this.destroyScormIframe();
  },
  methods: {
    destroyScormIframe() {
      if (!this.useNativePlayer) {
        const jq = window.jQuery || window.$;
        if (jq) {
          jq('#' + this.legacyHostId).empty();
        }
      }
      this.scormLaunched = false;
      this.scormLoading = false;
    },
    launchScorm() {
      if (this.scormLaunched) {
        return;
      }
      if (this.useNativePlayer && this.cveTema <= 0) {
        return;
      }
      if (!this.useNativePlayer && !(this.requerimiento && this.requerimiento.link)) {
        this.onScormError('No hay enlace SCORM para este tema');
        return;
      }
      this.scormLoading = true;
      this.scormLaunched = true;
      if (!this.useNativePlayer) {
        this.$nextTick(() => {
          launchScormIframe('#' + this.legacyHostId, {
            url: this.requerimiento.link,
            cveEmpleado: this.cveEmpleado,
            iframeHeight: this.iframeHeight,
            onLoaded: () => this.onScormReady(),
          });
        });
      }
    },
    onScormReady() {
      this.scormLoading = false;
      this.$emit('ready');
    },
    onScormError(message) {
      this.scormLoading = false;
      this.$emit('error', message);
    },
    cleanup() {
      this.destroyScormIframe();
    },
  },
};
</script>

<style scoped>
.scorm-player-wrapper {
  position: relative;
  width: 100%;
}
.scorm-iframe-loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.92);
}
.scorm-iframe-loader__text {
  color: #495057;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Scorm/ScormMaterialGate.vue